<template>
  <div
    id="selected-point-popup"
    :style="
      selectedPoint ? 'border: solid ' + selectedPoint.layerType.color : ''
    "
  >
    <div class="d-flex flex-column text-body-2 ma-1">
      <div>
        <b>{{ selectedPointCoordinates }}</b>
      </div>
      <div>{{ selectedPointData }} kWh</div>
      <div>
        {{ selectedPointStationCount }}
        {{ selectedPointStationCount > 1 ? "Punkte" : "Punkt" }}
      </div>
    </div>
  </div>
</template>

<script>
import { toLonLat } from "ol/proj";
import { toStringHDMS } from "ol/coordinate";

/**
 * Map overlay to display small info popup for selected point layer points.
 */
export default {
  name: "SelectedPointOverlay",
  props: {
    selectedPoint: Object
  },
  computed: {
    selectedPointCoordinates() {
      if (!this.selectedPoint) {
        return null;
      }
      let coordinates = this.selectedPoint.feature.getGeometry()
        .flatCoordinates;
      return toStringHDMS(toLonLat(coordinates));
    },
    selectedPointData() {
      if (!this.selectedPoint) {
        return null;
      }
      let feature = this.selectedPoint.feature;
      return typeof feature.get("data") == "number"
        ? Math.round(feature.get("data"))
        : "";
    },
    selectedPointStationCount() {
      if (!this.selectedPoint) {
        return null;
      }
      return this.selectedPoint.feature.get("station_count");
    }
  }
};
</script>

<style scoped>
/* see https://projects.verou.me/bubbly/ */
#selected-point-popup {
  position: relative;
  border-radius: 0.4em;
  background: lightcyan;
  white-space: nowrap;
}
#selected-point-popup:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-top-color: black;
  border-bottom: 0;
  margin-left: -8px;
  margin-bottom: -8px;
}
</style>
